import styled, { css } from "styled-components";
import { socketServer } from "../../assets/socketConnection";

// console.log(process.env);
// // alert("hi");
// const xx = "process.env.mainServer";

const profileImgStyles = (profile_img) => css`
  background-image: url("${socketServer}uploaded_profile_images/${profile_img}.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;

export const SelectedBitContStyled = styled.div`
  & > .selected-bit__title {
    display: flex;
    align-items: center;
    background-color: #ecedf0;
    padding: 6px;
    border-radius: 12px;
  }

  & .selected-bit__img {
    width: 48px;
    height: 48px;
    margin-left: 12px;

    border: solid 1px #2a2e43;
    background-color: rgba(42, 46, 67, 0.2);
    border-radius: 8px;

    ${({ profile_img }) => (profile_img ? profileImgStyles(profile_img) : null)}
  }

  & > .selected-bit__price {
    padding: 6px;
    border-radius: 8px;
    text-align: center;
    font-size: 1.2em;
    margin-top: 30px;
    background-color: #ffbf1d;
  }
`;
